import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import EditPersonalInfo from "../../components/dashboard/profilePartials/EditPersonalInfo";
import { useGeneral } from "../../components/contexts/GeneralContext";
import { useEffect, useState } from "react";
import axios from "../../config/axios";
import FullScreenLoading from "../../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../../components/common/ApiErrorMessage";
import NoItemsFound from "../../components/common/NoItemsFound";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("/dashboard/profile/personal-info");
        if (active) setContent(data?.item || null);
        const storedUser =
          JSON.parse(localStorage.getItem("loggedInUser")) || {};

        // ✅ Extract image filename (from backend or uploaded file)

        // ✅ Merge updated user data (save only image name)
        const updatedUser = {
          ...storedUser,
          image: data?.item?.image,
        };

        // ✅ Save to localStorage
        localStorage.setItem("loggedInUser", JSON.stringify(updatedUser));
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const PersonalInfoUpdatePage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true}
            component={
              <>
                {!loading && error ? (
                  <ApiErrorMessage
                    message1="Something went wrong"
                    message2="Please check your connection and try again."
                  />
                ) : !loading && !content ? (
                  <NoItemsFound
                    message1="Personal details unvailable"
                    message2="Please check back later."
                  />
                ) : (
                  content && <EditPersonalInfo content={content} />
                )}
              </>
            }
          />
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default PersonalInfoUpdatePage;
